<template>
  <transition name="fade" mode="out-in" appear>

    <div class="comp-psap-event-media">

      <template v-if="mediaType === 'video'">

        <CompPsapEventVideo v-on:onVideoErr="videoError"/>

      </template>
      <template v-else-if="mediaType === 'snapshot'">

        <CompPsapEventSnapshot/>

      </template>
      <template v-else>

        <CompMediaPlaceholder/>

        <div class="no-media-text-wrapper">
          <div class="no-media-text">No media available</div>
        </div>

      </template>

    </div>

  </transition>
</template>

<script>
import CompMediaPlaceholder from '@/components/CompMediaPlaceholder'
import CompPsapEventVideo from '@/components/CompPsapEventVideo'
import CompPsapEventSnapshot from '@/components/CompPsapEventSnapshot'
export default {
  name: 'comp-psap-event-media',
  components: {
    CompMediaPlaceholder,
    CompPsapEventVideo,
    CompPsapEventSnapshot
  },
  props: {
    infoFontSize: {
      type: String,
      default: function () {
        return '16px'
      }
    },
    autoPlay: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    isControllable: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  computed: {
    psapEventMedias: function () {
      return this.$store.getters.psapEventMedias
    },
    psapEventRecords: function () {
      return this.$store.getters.psapEventRecords
    },
    statusGetPsapEventMedias: function () {
      return this.$store.getters.statusGetPsapEventMedias
    },
    statusCheckPsapVideoCodec: function () {
      return this.$store.getters.statusCheckPsapVideoCodec
    }
  },
  data: function () {
    return {
      mediaType: '',
      isVideoMediaAvaliable: false,
      isSnapshotMediaAvaliable: false,
      isH264Video: false
    }
  },
  watch: {
    statusGetPsapEventMedias: function () {
      this.updateMediaPlayer()
    },
    statusCheckPsapVideoCodec: function () {
      if (this.statusCheckPsapVideoCodec === 'successful') {
        console.log('statusCheckPsapVideoCodec')
        this.updateMediaPlayer()
      }
    }
  },
  created: function () {
    this.init()
  },
  beforeDestroy: function () {
  },
  methods: {
    init: function () {
      this.updateMediaPlayer()
      this.getPsapEvent()
    },
    getPsapEvent: function () {
      this.$logger.info('getPsapEvent')
      this.$store.dispatch('getPsapEvent')
    },
    // ////////////////////////////////////////
    // UPDATE VARS - Media Player
    // ////////////////////////////////////////
    updateMediaPlayer: function () {
      // CHECK 1
      if (!this.psapEventMedias) return

      // INIT 1
      this.isVideoMediaAvaliable = false
      this.isSnapshotMediaAvaliable = false
      // GET recordInfo - VIDEO (MP4) and Snapshot (JPG)
      for (let index = 0; index < this.psapEventMedias.length; index++) {
        // CHECK
        let recordInfo = {...this.psapEventMedias[index]}
        if (!(recordInfo instanceof Object)) continue

        // CHECK
        if (recordInfo.format !== 'mp4' && recordInfo.format !== 'jpg') continue
        if (!recordInfo.statusInfo.completed) continue

        // UPDATE - isVideoMediaAvaliable
        if (recordInfo.format === 'mp4') {
          if (recordInfo.statusInfo.codec === 'h264') {
            this.isVideoMediaAvaliable = true
          } else if (recordInfo.statusInfo.codec !== null) {
            this.isVideoErr = true
          } else {
            let videoUrl = recordInfo.url
            let recordId = recordInfo.recordId
            let videoIndex = index
            this.downloadEventMedia(videoIndex, recordId, videoUrl)
          }
          continue
        }
        // UPDATE - isSnapshotMediaAvaliable
        if (recordInfo.format === 'jpg') {
          this.isSnapshotMediaAvaliable = true
        }
      }

      // UPDATE mediaType - HAS VIDEO
      if (this.isVideoMediaAvaliable) {
        this.mediaType = 'video'
        return
      }
      // UPDATE mediaType - HAS SNAPSHOT
      if (this.isSnapshotMediaAvaliable) {
        this.mediaType = 'snapshot'
      }

      if (!this.isSnapshotMediaAvaliable && !this.isVideoMediaAvaliable && this.isVideoErr) {
        this.$emit('onEventErr', true)
      }
    },
    videoError: function () {
      this.isVideoErr = true
      this.mediaType = 'snapshot'
    },
    downloadEventMedia: function (videoIndex, recordId, videoUrl) {
      this.$logger.info('downloadEventVideo: requested: recordId({recordId})'
        .replace('{recordId}', recordId))
      this.$store.dispatch('getPsapEventRecord', {
        snapshotIndex: videoIndex,
        recordId: recordId,
        url: videoUrl
      })
    }
  }
}
</script>

<style scoped>
.comp-psap-event-media {
  /* common */
  background-color: #fff;
  color: #333;
  font-size: 14px;
  outline: 1px solid #fff;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
}

.comp-psap-event-media .no-media-text-wrapper {
  /* size */
  width: 100%;
  padding-top: calc(100% / 16 * 9);
  /* position */
  position: absolute;
  bottom: 0;
  left: 0;
}
.comp-psap-event-media .no-media-text-wrapper .no-media-text {
  /* common */
  font-size: 1em;
  color: #fff;
  background-color: hsla(0, 0%, 20%, 1);
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/CompPsapEventMedia.vue